<!--Info Text-->
<!-- <div>
    <label>
        TO CHANGE Tardy Times: Select 'Correlate Tardy Time',
        click the row to change, change time, Click 'Set Time'.
    </label>
</div> -->

<p-confirmDialog key="main" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Box-->
<div class="MenuBox">
	<!--Top Section-->
	<div>
		<!--School Select-->
		<div class="SchoolSelectRow">
			<label style="margin: 0px">School:</label>
			<!-- <select class="form-control" name="SchoolSelector" [(ngModel)]="SchoolID" (ngModelChange)="onSchoolChange($event)">
                <option *ngFor="let r of lstSchool" [ngValue]="r.SchoolID">[{{r.SchoolNumber}}] - {{r.SchoolName}}</option>
            </select> -->

			<caass-schoolselector [ShowAll]="false" [Disabled]="loading" [TableTypeID]="5"> </caass-schoolselector>
		</div>

		<!--Correlate Time row-->
		<div class="CorrelateRow">
			<label style="margin: 0px">Correlate Tardy Time:</label>

			<select [disabled]="loading" class="form-control" [(ngModel)]="CorrelateSelectID" (ngModelChange)="onCorrelateSelectChange($event)">
				<option *ngFor="let o of lstCorrelateSelect" [ngValue]="o.ID">
					{{ o.Desc }}
				</option>
			</select>

			<button [disabled]="loading" style="margin: 0px" class="btn btn-primary" (click)="onSetCorrelation()">Set Correlation</button>
		</div>

		<!--Test Validity-->
		<div class="TwoItemRow">
			<label style="margin: 0px">Click 'TEST Tardy Validity' button to verify school's Tardy Settings</label>
			<button [disabled]="loading" style="margin: 0px" class="btn btn-primary" (click)="onTestValidity()">TEST Tardy Validity</button>
		</div>
	</div>

	<!--Table-->
	<div>
		<caass-school-grid *ngIf="CorrelateSelectID == 0 && loading == false" [SchoolID]="SchoolID"> </caass-school-grid>

		<caass-academy-grid *ngIf="CorrelateSelectID == 1 && loading == false" [SchoolID]="SchoolID"> </caass-academy-grid>

		<caass-grade-grid *ngIf="CorrelateSelectID == 2 && loading == false" [SchoolID]="SchoolID"> </caass-grade-grid>

		<caass-homeroom-grid *ngIf="CorrelateSelectID == 3 && loading == false" [SchoolID]="SchoolID"> </caass-homeroom-grid>

		<caass-start-period-grid *ngIf="CorrelateSelectID == 4 && loading == false" [SchoolID]="SchoolID"> </caass-start-period-grid>
	</div>
</div>

<!--Default Exit Time-->
<div class="MenuBox">
	<div class="FourItemRow">
		<label style="margin: 0px">Default School Exit Time:</label>

		<p-calendar
			[disabled]="loading"
			[(ngModel)]="SchoolExitTime"
			showIcon="true"
			showButtonBar="true"
			showTime="true"
			hourFormat="12"
			timeOnly="true"
			(ngModelChange)="onSchoolExitTimeChange($event)"
		></p-calendar>

		<button [disabled]="loading" style="margin: 0px" class="btn btn-primary" (click)="onUpdateExitTime()">Update Time</button>

		<button [disabled]="loading" style="margin: 0px" class="btn btn-primary" (click)="onResetExitTime()">Reset Time</button>
	</div>

	<div class="ExitEarlyRadioGrid">
		<input class="CHK" type="radio" name="ExitScan_EarlyBySchoolOnly" [(ngModel)]="ExitScan_EarlyBySchoolOnly" [value]="false" id="LeaveAfterLastPeriod" />
		<label for="LeaveAfterLastPeriod">Let students leave after their last period</label>

		<input class="CHK" type="radio" name="ExitScan_EarlyBySchoolOnly" [(ngModel)]="ExitScan_EarlyBySchoolOnly" [value]="true" id="LeaveAtExitTime" />
		<label for="LeaveAtExitTime">Students can't leave before {{ SchoolExitTimeDesc }} even if they have no classes in their schedule</label>
	</div>

	<div *ngIf="IsChanged() == true" class="WarningDiv">
		<label class="WarningText">* Press Update Time to save changes</label>
	</div>
</div>
